import { useAuth0 } from '@auth0/auth0-react';

function UserProfile() {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="d-flex align-items-center">
      <img
        src={user.picture}
        alt={user.name}
        className="rounded-circle me-2"
        width="32"
        height="32"
      />
      <span className="text-white">{user.name}</span>
    </div>
  );
}

export default UserProfile;
